module.exports = __webpack_public_path__ + "static/img/increase-lead-data03.2212fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/increase-lead-data03.png
// module id = MEXo
// module chunks = 1